import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: 'What is com0.org?',
      answer: 'com0.org is a modern domain registry that offers innovative domain extension combining the credibility of .com and .org. We provide transparent, at-cost pricing with no hidden fees.',
    },
    {
      question: 'How is pricing determined?',
      answer: 'We charge at-cost pricing, meaning you pay only the wholesale price set by domain registry. There are no markups, hidden fees, or inflated renewal costs. What you see is what you pay.',
    },
    {
      question: 'Do you offer WHOIS privacy protection?',
      answer: 'Yes! We provide free WHOIS privacy protection on all domain registrations. Your personal information is redacted from public WHOIS databases, protecting you from spam and potential threats.',
    },
    {
      question: 'Can I sell or transfer domains to another party?',
      answer: 'Selling and transferring of domain ownership is strictly prohibited at com0.org to reduce spam.',
    },
    {
      question: 'What payment methods do you accept?',
      answer: 'We accept all major credit cards (Visa, MasterCard, American Express), PayPal, and bank transfers for enterprise customers. All transactions are secure and encrypted.',
    },
    {
      question: 'Is there a refund policy?',
      answer: 'Yes, we offer a limited time bounded refund policy for genuine concerns.',
    },
  ];

  return (
    <section id="faq" className="py-20 px-4 sm:px-6 lg:px-8 bg-section-faq">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-theme-primary mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-theme-secondary">
            Everything you need to know about com0.org
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="glass-card rounded-xl overflow-hidden"
            >
              <button
className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-white/10 transition-colors"
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
              >
                <span className="font-semibold text-theme-primary">{faq.question}</span>
                {openIndex === index ? (
                  <ChevronUp className="h-5 w-5 text-theme-tertiary shrink-0" />
                ) : (
                  <ChevronDown className="h-5 w-5 text-theme-tertiary shrink-0" />
                )}
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4">
                  <p className="text-theme-secondary">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
